(() => {
  if (window.hycHomepage) return;
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  function selectTab(section, tab, focus = false) {
    section.querySelectorAll('[role="tab"]').forEach(item => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
    if (focus) tab.focus();
  }
  function updateCarousel(section) {
    const track = section.querySelector('.hy-carousel-track');
    if (!track) return;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
    section.querySelector('[data-hyc-prev]').disabled = track.scrollLeft <= 3;
    section.querySelector('[data-hyc-next]').disabled = atEnd;
  }
  function init(root = document) {
    root.querySelectorAll('[data-hyc-process]').forEach(section => {
      if (section.dataset.hycReady) return;
      section.dataset.hycReady = 'true';
      const tabs = [...section.querySelectorAll('[role="tab"]')];
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(section, tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); selectTab(section, tabs[next], true); }
        });
      });
    });
    root.querySelectorAll('[data-hyc-carousel]').forEach(section => {
      if (section.dataset.hycReady) return;
      section.dataset.hycReady = 'true';
      const track = section.querySelector('.hy-carousel-track');
      const move = direction => {
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 20;
        track.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || track.clientWidth) + gap), behavior: motion() });
      };
      section.querySelector('[data-hyc-prev]').addEventListener('click', () => move(-1));
      section.querySelector('[data-hyc-next]').addEventListener('click', () => move(1));
      track.addEventListener('scroll', () => updateCarousel(section), { passive: true });
      requestAnimationFrame(() => updateCarousel(section));
    });
  }
  window.hycHomepage = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[role="tabpanel"]');
    if (panel) {
      const section = panel.closest('[data-hyc-process]');
      const tab = document.getElementById(panel.getAttribute('aria-labelledby'));
      if (section && tab) selectTab(section, tab);
    }
    const track = event.target.closest('.hy-carousel-track');
    if (track) {
      const card = event.target.closest('.hy-product-card, .hy-ugc-card');
      if (card) track.scrollBy({ left: card.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: 'auto' });
    }
  });
  window.addEventListener('resize', () => document.querySelectorAll('[data-hyc-carousel]').forEach(updateCarousel), { passive: true });
})();
